import Navbar from "../../components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import ValuesSection from "./components/ValuesSection";
import SocialProofSection from "./components/SocialProofSection";
import ChallengeGallery from "./components/ChallengeGallery";
import CTASection from "./components/CTASection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <div className="bg-white font-sans">
      <Navbar />
      <HeroSection />
      <ValuesSection />
      <SocialProofSection />
      <ChallengeGallery />
      <CTASection />
      <FooterSection />
    </div>
  );
}
